import MDBox from "../../components/MDBox";
import MDButton from "../../components/MDButton";
import Icon from "@mui/material/Icon";
import {Card, Chip} from "@mui/material";
import Avatar from "@mui/material/Avatar";
import {formatCurrency} from "../common/Utils";
import React, {useContext, useEffect, useState} from "react";
import PopupState, {bindMenu, bindTrigger} from "material-ui-popup-state";
import Menu from "@mui/material/Menu";
import NotificationItem from "../Items/NotificationItem";
import Confirm from "../common/Confirm";
import {deleteEventPackage, getInventoryEventPackages, saveInventoryEventPackage} from "../common/api/InventoryApi";
import {AppContext} from "../../lib/AppContext";
import ManageEventTypePackageModal from "./ManageEventTypePackageModal";

export default function EventPackages({savingCompany}) {

  const [context, setContext] = useContext(AppContext);

  const [eventPackage, setEventPackage] = useState(null);
  const [manageEventPackage, setManageEventPackage] = useState(false);
  const [confirmDeletePackage, setConfirmDeletePackage] = useState(false);
  const [confirmation, setConfirmation] = useState(null);
  const [eventPackages, setEventPackages] = useState([]);
  const [saving, setSaving] = useState(false);

  const loadEventPackages = () => {
    getInventoryEventPackages().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setEventPackages(result);
      }
    });
  }

  useEffect(()=> {
    loadEventPackages();
  }, [])

  const handleDeletePackage = async (eventPackage) => {
    let result = await deleteEventPackage(eventPackage?.inventory.guid);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setConfirmDeletePackage(false);
      loadEventPackages();
    }
  }

  const manageEventPackageFn = (eventPackage) => {
    let t = null;
    if (eventPackage) {
      t = {...eventPackage};
    }
    setEventPackage(t);
    setManageEventPackage(true);
  }

  const closeEventPackageFn = () => {
    setEventPackage(null);
    setManageEventPackage(false);
  }

  const saveEventPackageFn = async (eventPackage) => {
    let result = await saveInventoryEventPackage(eventPackage);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      closeEventPackageFn();
      loadEventPackages();
    }
  }

  const addEventPackageFn = () => {
    manageEventPackageFn();
  }

  const confirmDeleteInventoryPackage = (eventPackage) => {
    let confirmation = {
      title: 'Archive ' + eventPackage?.inventory.name + '?',
      message: 'Confirm archive ' + eventPackage?.inventory.name + '?',
      entity: eventPackage
    }
    setConfirmation(confirmation);
    setConfirmDeletePackage(true);
  }

  const EventPackageActions = ({item}) => {
    return (<PopupState variant="popover" popupId={'inventory-popup-menu-' + item.id}>
      {(popupState) => (
        <>
          <MDButton {...bindTrigger(popupState)}
                    variant="outlined"
                    color="secondary"
                    size="small"
                    circular
                    iconOnly
          >
            <Icon>more_horiz</Icon>
          </MDButton>
          <Menu {...bindMenu(popupState)}>
            <NotificationItem
              onClick={(e) => {
                popupState.close();
                manageEventPackageFn(item)
              }} icon={<Icon>edit</Icon>} title="Edit"/>
            <NotificationItem onClick={(e) => {
              popupState.close();
              confirmDeleteInventoryPackage(item)
            }} icon={<Icon>delete</Icon>} title="Archive"/>
          </Menu>
        </>
      )}
    </PopupState>);
  }

  return (
    <>
    <Card>
      <MDBox p={3}>
        <h5>
          Event Packages
          <MDButton
            color="secondary"
            size="small"
            className={'pull-right'}
            onClick={(e) => {
              addEventPackageFn();
            }}>
            <Icon>event</Icon>&nbsp;Add Event Package
          </MDButton>
        </h5>
        <p className={'py-2 fw-light'}>
          Use Event Packages to extends Birthday Party offerings, upgrades, and add-ons. For example, you
          might have packages for "Gold," "Silver," or "Bronze."
        </p>
        <ul className={'list-group'}>
          {eventPackages.map((eventPackage, index) => {
            return (
              <li
                className={'list-group-item '}
                key={index}>
                {eventPackage?.inventory.id && eventPackage?.inventory.name &&
                  <>
                                  <span className="d-block pull-right">
                                    <EventPackageActions item={eventPackage}/>
                                  </span>
                    <a
                      href={'#'}
                      onClick={(e) => {
                        e.preventDefault();
                        manageEventPackageFn(eventPackage);
                      }}>
                      {eventPackage?.inventory.name}
                    </a>
                  </>
                }
                <p style={{
                  clear: 'both'
                }}>
                  <small className={'text-small my-n2 d-block cls clear-both'}>
                    {eventPackage?.inventory.desc}
                  </small>
                </p>

                {eventPackage?.inventory?.imageUrl &&
                  <Chip
                    size="small"
                    className={'m-1 mb-n1'}
                    avatar={<Avatar
                      src={eventPackage?.inventory?.imageThumbUrl || eventPackage?.inventory?.imageUrl}/>}
                    label={'Price: ' + formatCurrency(eventPackage?.inventory?.price)}
                    variant="filled"
                    color="secondary"/>
                }
                {!eventPackage?.inventory?.imageUrl &&
                  <Chip
                    size="small"
                    className={'m-1 mb-n1'}
                    avatar={<Avatar><span className="fa fa-gift"/></Avatar>}
                    label={'Price: ' + formatCurrency(eventPackage?.inventory?.price)}
                    variant="filled"
                    color="info"/>
                }

                {eventPackage?.inventory?.eventType && <>
                  <Chip
                    size="small"
                    className={'m-1 mb-n1'}
                    avatar={<Avatar><Icon>event</Icon></Avatar>}
                    label={'Event Type: ' + eventPackage?.inventory?.eventType.name}
                    variant="filled"
                    color="secondary"/>
                </>}

                {eventPackage?.assignedInventories?.sort((a, b) => a.id - b.id).map((group, index) => {
                  return (
                    <Chip
                      key={index}
                      size="small"
                      className={'m-1 mb-n1'}
                      index={index}
                      avatar={<Avatar
                        src={group?.imageThumbUrl || group?.imageUrl}/>}
                      label={group?.name}
                      variant="outlined"
                      color="secondary"/>
                  )
                })
                }

              </li>
            )
          })}
        </ul>
      </MDBox>
    </Card>

      {manageEventPackage && <ManageEventTypePackageModal
        eventPackage={eventPackage}
        show={manageEventPackage}
        saving={savingCompany}
        handleSave={saveEventPackageFn}
        handleClose={closeEventPackageFn}
      />}

      {confirmDeletePackage && <Confirm confirmation={confirmation}
                                        show={confirmDeletePackage}
                                        saving={saving}
                                        handleSave={() => {
                                          setConfirmDeletePackage(false);
                                          setConfirmation(null);
                                        }}
                                        handleConfirm={handleDeletePackage}
                                        handleClose={() => {
                                          setConfirmDeletePackage(false);
                                          setConfirmation(null);
                                        }}/>}
  </>
  )
}